import React from 'react';
import PropTypes from 'prop-types';
import { apiAction, get, pageContext } from 'ctm-util-functions';
import { useDispatch, useSelector } from 'react-redux';
import Immutable from 'immutable';
import { quoteIdSelector } from 'ctm-selectors';
import { InternalLink } from '../../internal_link/internal_link';
import * as actions from '../actions';

const KeyInformation = (props) => {
    const dispatch = useDispatch();
    const { onClickMoreInfo, stateProps, api, moreInfoHref, moreInfoDataIdBase } = props;
    const quoteId = useSelector(quoteIdSelector) || 0;
    const productId = get(stateProps, 'product.productMeta.id');
    const dataId = `${moreInfoDataIdBase}.${productId}`;
    const handleClick = () => {
        if (moreInfoHref) {
            dispatch(actions.setProductId(productId));
            dispatch(actions.setQuoteId(quoteId));
            dispatch(onClickMoreInfo);
            dispatch(apiAction(api, pageContext.getProps().pageState));
        }
    };

    return (
        <InternalLink
            href={moreInfoHref || '#'}
            label="Key information"
            data-id={dataId}
            onClick={handleClick}
        />
    );
};

KeyInformation.propTypes = {
    moreInfoHref: PropTypes.string.isRequired,
    moreInfoDataIdBase: PropTypes.string.isRequired,
    api: PropTypes.object.isRequired,
    onClickMoreInfo: PropTypes.object.isRequired,
    stateProps: PropTypes.shape({
        product: PropTypes.instanceOf(Immutable.Map)
    })
};

export { KeyInformation };
